import { render, staticRenderFns } from "./AppointmentList.vue?vue&type=template&id=785e2638&scoped=true&"
import script from "./AppointmentList.vue?vue&type=script&lang=js&"
export * from "./AppointmentList.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentList.vue?vue&type=style&index=0&id=785e2638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e2638",
  null
  
)

export default component.exports